import { DataAttributeDefinitions } from 'scrivito'

import { pisaSocialNetworkDataClass } from './Pisa/pisaSocialNetworkDataClass'

const attributes: DataAttributeDefinitions = {}

export const SocialNetwork = pisaSocialNetworkDataClass(attributes)
